var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.115 7.896a1.024 1.024 0 0 1 1.024-.26l.736.222V.142L.215 2.806A.344.344 0 0 0 0 3.125v14.438a.344.344 0 0 0 .472.319l6.314-2.526-1.93-6.435a1.03 1.03 0 0 1 .259-1.025ZM13.75 2.617 7.562.142v7.922L13.75 9.92V2.617ZM21.162.09a.344.344 0 0 0-.32-.034l-6.404 2.561v7.51l2.015.604a1.033 1.033 0 0 1 .087 1.945l-2.102.84v4.28l6.659-2.664a.344.344 0 0 0 .215-.32V.376a.344.344 0 0 0-.15-.285ZM13.75 13.792l-1.957.783-.84 2.101 2.797 1.12v-4.004Z",
    fill: "#3483DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.255 11.39 5.942 8.296a.345.345 0 0 0-.428.428l3.094 10.312a.344.344 0 0 0 .648.03l2.009-5.02 5.02-2.008a.344.344 0 0 0-.03-.649Z",
    fill: "#3483DF"
  })));
};
export default SvgMap;